import DOMPurify from 'dompurify'

type SafeHtmlContentProps = {
  html: string
}

const SafeHtmlContent = ({ html }: SafeHtmlContentProps) => {
  const safeHtml = DOMPurify.sanitize(html)
  return <span dangerouslySetInnerHTML={{ __html: safeHtml }} />
}

export default SafeHtmlContent
